import styled from 'styled-components';
import React from 'react';
import classnames from 'classnames';
import colors from '../../utils/colors';
import {rem} from 'polished';
import BaseButton from './BaseButton';
import buttonThemes from './buttonThemes';
import colorThemes from '../colorThemes';

const StyledButton = styled.button`
	font-size: 1rem;
	font-family: FyranSans-SemiBold;
	background: ${colors.BRAND_RED};
	color: ${colors.WHITE};
	border: 2px solid ${colors.BRAND_RED};
	border-radius: 999px;
	padding: ${rem('10px')} ${rem('25px')};
	cursor: pointer;
	align-self: center;
	white-space: nowrap;
	line-height: 1.25rem;

	.icon-wrap {
		display: inline-block;
		padding: 0 ${rem('10px')};
		height: 1.25rem;
		box-sizing: border-box;
	}

	&.icon {
		padding-left: ${rem('8px')};
	}

	&.icon-right {
		padding-right: ${rem('8px')};
	}

	&.disabled {
		pointer-events: none;
		background: ${colors.WHITE};
		color: ${colors.GRAY};
		border: 2px solid ${colors.GRAY};
	}

	${props => props.theme && props.theme === buttonThemes.TEXT && `
    color: inherit;
		font-size: inherit;
    font-family: inherit;
    padding: 0;
    background: none;
    border: 0;

		.icon-wrap {
			padding-left: 0;
			svg {
				vertical-align: top;
			}
		}

		&.icon {
			padding-left: 0;
		}
		&.icon-right {
			padding-right: 0;
		}
	`}

	${props => props.theme && props.theme === buttonThemes.SECONDARY && `
   	background: ${colors.WHITE};
    color: ${colors.BRAND_RED};
  `}

  ${props => props.theme && props.theme === colorThemes.LIGHT && `
   	background: ${colors.WHITE};
		color: ${colors.GRAY_DARKER};
	  border: 2px solid ${colors.GRAY_LIGHT};

		.icon-wrap {
			color: ${colors.GRAY_LIGHT};
		}
  `}

  ${props => props.theme && props.theme === buttonThemes.LIGHT_INVERSE && `
   	background: ${colors.TRANSPARENT} !important;
		color: ${colors.WHITE};
	  border: 2px solid ${colors.GRAY_LIGHTER};

	  &.disabled {
	  	opacity: 0.7;
	  }
  `}

  ${props => props.theme && props.theme === colorThemes.DARK && `
    background: ${colors.BLACK};
    color: ${colors.WHITE};
    border: 2px solid ${colors.WHITE};
  `}

   ${props => props.minWidth && `
    min-width: ${rem('200px')};
  `}
`;

class Button extends BaseButton {
	render() {
		const {
			children,
			className,
			...rest
		} = this.props;

		const buttonClassname = classnames(className, {
			'disabled' : this.props.disabled,
			'icon': this.props.icon && !this.props.iconRight,
			'icon-right': this.props.icon && this.props.iconRight,
			'toggled': this.props.toggled,
		});

		return (
			<StyledButton
				onClick={this.props.onClick}
				className={buttonClassname}
				{...rest}
			>
				{this.icon(false)}
				{children}
				{this.icon(true)}
			</StyledButton>
		);
	}
}

export default Button;





// WEBPACK FOOTER //
// ./src/ui/button/Button.js